import { createError } from './create-error';
export const ConfigManagerError = createError('ConfigManagerError', 'Failed to update configuration', {
  LOCKED: 'Manager is locked. Update configuration before connecting.'
});